module.exports = __webpack_public_path__ + "static/media/TOYS.99863e53.png";